import Image from 'app/Components/Shared/Image/image';
import React, {memo, useState} from 'react';
import QuestionAnswerItemBlockData from '../../../Models/Content/QuestionAnswerItemBlockData';
import classNames from 'classnames';
import {Collapse} from 'reactstrap';
import reactStringReplace from 'react-string-replace';
import {isMobile} from 'react-device-detect';
import {gaEvent} from '../../../utilities/analytics/tracking';
import gaParams from '../../../utilities/analytics/constants';

type QuestionAnswerItemBlockProps = {
  data: QuestionAnswerItemBlockData;
  isBusiness: boolean;
  onOpen(): void;
  eCategory: number;
  abroadPackagesList: null;
  isSeparatedSale?: boolean;
};

const QuestionAnswerItemBlock = ({
  isBusiness,
  onOpen,
  data: {answer, question},
  eCategory,
  abroadPackagesList,
  isSeparatedSale,
}: QuestionAnswerItemBlockProps) => {
  const [open, setOpen] = useState(false);
  const search = 'עמוד תוצאות חיפוש';
  const lobby = 'עמוד לובי';
  return (
    <div className={classNames('QuestionAnswerItemBlock', {buisness: isBusiness})}>
      <div className='QuestionAnswerItemBlock__wrapper' style={isMobile ? {border: 'solid 1px #e0e5e8', borderRadius: '4px'} : null}>
        {/* style={isMobile?{borderRadius: '4px' ,border:'solid 1px #e0e5e8'}:''} */}
        <div
          className='QuestionAnswerItemBlock__question'
          onClick={() => {
            open || onOpen();
            setOpen(!open);
            let section = abroadPackagesList ? search : lobby;

            if (!open) {
              if (isSeparatedSale) {
                gaEvent(
                  gaParams.SEPARATED_FAQQUESTION_CLICK.category,
                  gaParams.SEPARATED_FAQQUESTION_CLICK.eventType,
                  `${eCategory}/${section}`
                );
              } else {
                if (isBusiness) {
                  gaEvent('hul_sale_business', 'click_21', `${eCategory}/${section}`);
                } else gaEvent('hul_sale_private', 'click_33', `${eCategory}/${section}`);
              }
            }
          }}>
          <div>
            {reactStringReplace(question.value, '?', (m, index) => (
              <span className='highlight' key={index}>
                {m}
              </span>
            ))}{' '}
          </div>
          <div className='circle'>
            {isBusiness && (
              <Image className={classNames('QuestionAnswerItemBlock__question__arrow', {open})}
                src={require('./images/arrow-left-business.svg')} />
            )}
            {!isBusiness && (
              <Image className={classNames('QuestionAnswerItemBlock__question__arrow', {open})} src={require('./images/arrow-left.svg')} />
            )}
          </div>
        </div>
        <Collapse isOpen={open} className='QuestionAnswerItemBlock__answer'>
          <div className='QuestionAnswerItemBlock__answer__inner'>{answer.value}</div>
        </Collapse>
      </div>
    </div>
  );
};

export default memo(QuestionAnswerItemBlock);
